export default "__VITE_ASSET__DZufduu1__"